import React, { forwardRef, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import { FiCalendar, FiChevronDown } from "react-icons/fi";

interface PropsI {
    className?: string;
    onChange: (date: Date[])=>void
}

const BaseDatePicker = ({ className, onChange }: PropsI) => {
    const [selectedStartDate, setSelectedStartDate] = useState<Date>()
    const [selectedEndDate, setSelectedEndDate] = useState<Date>()

    const datePickerRef = useRef(null);

    const handleAutoFocus = () => {
        if(datePickerRef.current){
            // @ts-ignore
            datePickerRef.current.focus()
        }
    };

    const changeDate = (dates:Date[]) => {
        onChange(dates)
        const [start, end] = dates;
        setSelectedStartDate(start)
        setSelectedEndDate(end)
    }

    // @ts-ignore
    const CustomInputRef = forwardRef(({ value, onClick }, ref) => (
        <div className={`form__input--group ${className}`} onClick={onClick}>
            <div className="prepend__input">
                <FiCalendar className="text-2xl" />
            </div>
            <input value={value} className="form__input prepend append  max-w-[328px]" readOnly />
            <div className="append__input">
                <FiChevronDown className="text-2xl" />
            </div>
        </div>
    ));
    return (
        <DatePicker
            ref={datePickerRef}
            selected={selectedStartDate}
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            showMonthDropdown
            showYearDropdown
            // @ts-ignore
            onChange={(date: Date[]) => changeDate(date)}
            customInput={<CustomInputRef />}
            selectsRange
        />)
}
export default BaseDatePicker;